var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "#ECFDF3",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3334 40.7735V42.0001C55.3318 44.8754 54.4008 47.673 52.6792 49.9759C50.9576 52.2788 48.5378 53.9635 45.7806 54.7787C43.0233 55.5939 40.0764 55.496 37.3794 54.4996C34.6823 53.5032 32.3796 51.6616 30.8147 49.2496C29.2498 46.8375 28.5065 43.9842 28.6957 41.1152C28.8848 38.2462 29.9964 35.5152 31.8645 33.3296C33.7326 31.1439 36.2571 29.6207 39.0617 28.987C41.8662 28.3534 44.8004 28.6433 47.4268 29.8135M55.3334 31.3335L42.0001 44.6801L38.0001 40.6801",
    stroke: "#039855",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRound);
export default __webpack_public_path__ + "static/media/check-round.9637021aed9af0b898074b152d3ccc31.svg";
export { ForwardRef as ReactComponent };